<template>

    <div ref="diagram" :class="!isFull ? 'diagram' : 'full'" :style="kuan ? kuanStyle : ''">
        <div :class="!load?'move-box':'move-box load'">
            <div class="upmask">
                
                <div class="titleAll-nav" >
                    <div class="nav" >
                        <b>{{ title }}</b>
                    </div>
                </div>

                <div class="date">
                    <div class="time">
                        <div class="hour">{{currentDate.hour}}</div>
                        <div class="year">{{currentDate.year}}</div>
                    </div>
                    <div class="city">{{currentDate.city}}</div> 
                    <div class="weather">{{currentDate.temperatrue}}° <span>{{currentDate.weather}}</span></div>
                    <div class="humi"><span>湿度</span> {{currentDate.humi}}%</div>
                </div>
            </div>

            <!-- 加载 -->
            <div class="container" v-if="!loadEnd"> 
                <div class="text">
                    <Loading :width="widthLoad"></Loading>
                    {{'三维场景加载中... '}}
                </div>
            </div>


            <iframe name="Gis" width="100%" height="100%" ref="iframeWindow" class="small"
                :src="$store.state.project.projectInfo.webgisUrlWhite">
            </iframe>
            <!-- <div class="clickbtn-rongt" >
                <div :class="menuIdx == index?'nin_select selected':'nin_select'"  v-for="(item,index) in aside" :key="item.id" @click="sendMessage(item,index)">
                    <img :src="item.src" alt="" /><span>{{item.name}}</span>
                </div>
            </div> -->
            <router-link :to="'/3D/' + page" >
                <div class="Downmask1">
                    <img src="../../../assets/img/矢量智能对象.png" alt="" />
                    <p class="rouling">进入大屏显示</p>
                </div>
            </router-link>
        </div>
        <div class="btn row-center" v-show="!kuan" v-if="!isFull" @click="full">
            <!-- <img src="@/assets/img/fullScreen.png" alt="全屏"> -->
            <span><img src="@/assets/img/full.png" title="全屏"></span>
        </div>
        <div class="btn row-center" v-else @click="cancelFull">
            <!-- <img src="@/assets/img/full_cancel.png" alt="取消全屏"> -->
            <span><img src="@/assets/img/qwhite.png" title="取消全屏"></span>
        </div>

        <div class="btn row-center" v-if="!isFull && !kuan" @click="onkuan" style="right: 66rem">
            <!-- <img src="@/assets/img/fullScreen.png" alt="全屏"> -->
            <span style="margin-right: 18px"><img src="@/assets/img/widescreen.png" title="宽屏"></span>
        </div>

        <div v-show="!isFull" class="btn row-center" v-else @click="kuan = false" style="right: 20rem">
            <!-- <img src="@/assets/img/fullScreen.png" alt="全屏"> -->
            <span style=""><img src="@/assets/img/kwhite.png" title="取消宽屏"></span>
        </div>

        <!-- <div class="floor" v-show="selectBuild != ''">
            <div class="warp">
                <div :class="currentFloor == index?'flooritem se':'flooritem'" v-for="(item,index) in floorList" :key="index" @click="selectFloor(item,index)">
                    {{item}}
                </div>
            </div>
            <div class="top" @click="top"></div>
            <div class="bottom" @click="bottom"></div>
        </div> -->
    </div>

</template>
<script>
import Loading from '../../3D/Loading.vue'
    export default {
        data() {
            return {
                width:0,
                load:false,
                loadEnd:false,
                projectCoordinate:'', // 经纬度查询天气
                currentDate:{     // 当前时间天气
                    hour:'15:26:48',
                    year:'2022年03月15日',
                    city:'济宁',
                    weather:'多云',
                    temperatrue:'32',
                    humi:'63'
                },
                menuIdx:0,
                flag:true,
                page:'all',
                aside: [],
                asideArr: [
                    [{
                        id: 1,
                        name: "概况",
                        src: require("../../../assets/img/主视角.png"),
                        values: "parkOverview",
                        type:'park'
                    },
                    {
                        id: 2,
                        name: "站点",
                        src: require("../../../assets/img/站点概览.png"),
                        values: "parkOverview",
                        type:'site'
                    },
                    {
                        id: 3,
                        name: "建筑",
                        src: require("../../../assets/img/louyu_nor.png"),
                        values: "buildOverview",
                    }],
                    [{
                        id: 1,
                        name: "概况",
                        src: require("../../../assets/img/主视角.png"),
                        values: "parkOverview",
                        type:'park'
                    },
                    {
                        id: 2,
                        name: "CAD",
                        src: require("../../../assets/img/cascades.png"),
                        values: "",
                    },
                    {
                        id: 3,
                        name: "热力图",
                        src: require("../../../assets/img/relitu_nor.png"),
                        values: "",
                    }],
                ],
                //左侧菜单一开始选中的值
                current: 0,
                //延时器3M
                timer: "",
                kuan: false,
                isFull: false,
                url: "",
                id: 0,
                seat: require("../../../assets/img/ebs.png"),
                title: "",
                iframeWin: {},
                selectBuild:'', //三维场景内选中的楼宇
                floorList:[],  // 右侧楼层选择器
                floorList1:['11F','10F','9F','8F','7F','6F','5F','4F','3F','2F','1F'],  // 鲁泰大楼楼层
                floorList2:['3F','2F','1F'],  // 鲁泰裙楼层
                currentFloor:-1,  // 当前选中的楼层
            };
        },
        components:{
            Loading
        },
        mounted() {
            this.iframeWin = this.$refs.iframeWindow.contentWindow;
            window.addEventListener("message", this.handleMessage);
            let _this = this
            setTimeout(()=>{
                _this.iframeWin.postMessage({
                    cmd: "parkOverview",
                },"*")
                this.load = true
                console.log('进入三维');
            },3000)

            this.timer = setInterval(()=>{
                _this.formatDate("YYYY年MM月DD日 hh:mm:ss", new Date())
            },1000)
            setInterval(()=>{
                _this.getWeatherInfo()
            },10*60*1000)
            this.getCity()
            this.getWeatherInfo()
        },
        created(){
            this.aside = this.asideArr[0]
        },
        beforeDestroy() {
            window.removeEventListener("message", this, this.handleMessage);
            clearTimeout(this.timer);

        },
        watch: {
            currentFloor(val){
                if(val == -1){
                    this.aside = this.asideArr[0]
                }else{
                    this.aside = this.asideArr[1]
                }
            },
            widthLoad(width){
                let that = this
                if(width == 100){
                    this.timer = setTimeout(()=>{
                            that.loadEnd = true
                        },1000)
                }
            }
        },
        methods: {
            // 查询当前项目所在城市 
            getCity(location){
                fetch('https://geoapi.qweather.com/v2/city/lookup?location=' + this.$store.state.project.projectInfo.projectCoordinate +
                        '&key=154645a21e7c47c4bb5f0657c7b1ad63').then(res => res.json()).then(res=>{
                            this.currentDate.city = res.location[0].adm2
                        })
            },
            getWeatherInfo(location) {
                 // 和风天气api 10000/天 可通过经纬度查询
                fetch('https://devapi.heweather.net/v7/weather/now?location=' + this.$store.state.project.projectInfo.projectCoordinate +
                        '&key=154645a21e7c47c4bb5f0657c7b1ad63')
                    .then(response => response.json())
                    .then(json => { 
                        this.currentDate.temperatrue = json.now.temp;
                        this.currentDate.weather = json.now.text;
                        this.currentDate.humi = json.now.humidity;
                    })
            },
            // 初始化时间
            formatDate(fmt, date){
                let timeObj = {
                    "Y+":date.getFullYear().toString(),
                    "M+":(date.getMonth() + 1).toString(),
                    "D+":date.getDate().toString(),
                    "h+":date.getHours().toString(),
                    "m+":date.getMinutes().toString(),
                    "s+":date.getSeconds().toString(),
                }
                // console.log(timeObj);
                for (let k in timeObj) {
                    let ret = new RegExp("(" + k + ")").exec(fmt);
                    if (ret) {
                        fmt = fmt.replace(ret[1], ret[1].length == 1 ? timeObj[k] : timeObj[k].padStart(ret[1].length, "0"));
                    }
                }
                this.currentDate.year = fmt.substr(0,11)
                this.currentDate.hour = fmt.substr(12)
            },
            handleMessage(event) {
                const data = event.data;
                switch (data.cmd) {
                    case "loadProgress":
                        console.log(data.value);
                        this.width = data.value * 4    // 这里加速三维进入 动画 ，
                        break
                }
            },
            sendMessage(value,idx) {
                this.menuIdx = idx 
                this.selectBuild = ''
                this.aside = this.asideArr[0]
                this.iframeWin.postMessage({
                        cmd: value.values,
                        params:value.type
                },"*")
            },

            full() {
                this.isFull = true;
            },
            cancelFull() {
                this.isFull = false;
                this.reset();
            },

            onkuan() {
                this.kuan = true;
            },
            selectFloor(floor, index){
                this.currentFloor = index
                this.iframeWin.postMessage({
                        cmd: 'selectFloor',
                        params:{floor}
                },"*")
            },
            top(){

            },
            bottom(){

            }
        },
        computed: {
            kuanStyle() {
                if (this.kuan) {
                    return `
                        width: 84%;
                        height:90%;
                        position: fixed;
                        top: 6%;
                        left: 14%;
                        bottom: 0;
                        right: 0;
                        margin: auto;
                        z-index: 9999;
                    `;
                }
                return;
            },
            widthLoad(){
                let width = this.width < 100 ? this.width : 100
                return width
            }
        },
    };
</script>
<style lang="less" scoped>
    #ifromD {
        width: 100%;
        height: 100%;
    }

    .full {
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 1);
        z-index: 9999;
    }

    .diagram {
        width: 100%;
        height: 100%;
        overflow: hidden;
        // position: relative;
        background-color: rgba(0, 0, 0, 0);
    }

    /*定义滚动条轨道 内阴影+圆角*/


    .detail {
        font-size: 18rem;
        color: #fff;
        position: absolute;
        top: 24rem;
        left: 24rem;
        display: flex;
        align-items: center;
        cursor: pointer;
    }

    .tableContainer {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .move-box {
        width: 99.9%;
        height: 100%;
        position: relative;
        background-color: #ffffff;

            .container {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            background-image: url('../../../assets/img/threebj.png');
            background-size: 100% 100%;
            color: white;
            // opacity: 0.7;
            z-index: 999;

            .text {
                position: absolute;
                top: 85%;
                left: 50%;
                transform: translate(-50%, -50%);
                z-index: -1;
                font-size: 20rem;
                text-shadow: 0 0 20px #0D94FF , 0 0 20px #0D94FF , 0 0 20px #0D94FF ,;
                width: 40vw;
                height: 15vh;
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                align-items: center;
            }

        }
    }
    .load{
        width: 100%;
    }

    .small,
    .mask {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        /*transition: all 0.1s;*/
    }

    .mask {
        width: 100%;
        height: 100%;
    }

    .btn {
        position: absolute;
        bottom: 1vh;
        right: 24rem;
        color: #ffffff;
        font-size: 20rem;
        cursor: pointer;
        z-index: 111;
    }

    .upmask {
        height: 90rem;
        position: absolute;
        width: 100%;
        z-index: 9;
        background-image: linear-gradient(rgb(0, 0, 0, 1), rgba(0, 0, 0, 0));

        .titleAll-nav {
            .nav {
                font-size: 24px;
                color: #fff;
                padding: 20rem 0 0 26rem;
            }
        }
        .Op {
            font-size: 24px;
            color: #fff;
            padding: 20rem 0 0 26rem;
        }
        
        .date{
            // width: 370rem;
            height:40rem ;
            // background-color: #fff;
            position: absolute;
            color: #fff; 
            right: 20rem;
            top: 20rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-family: Source Han Sans CN;
            font-size: 24rem;

            .time{
                // width:120rem ;
                padding: 0 20rem;
                text-align: center;
                .hour{
                    font-weight: 500;
                }
                .year{
                    font-size: 14rem;
                    padding-left: 3rem;
                    margin-top: -8rem;
                }
            }
            .city{
                font-weight: 500;
                padding: 0 16rem;
                border-left: 1px solid #fff;
                border-right: 1px solid #fff;
            }
            .weather{
                padding:0 10rem;
                span{
                    font-size: 16rem;
                }
            }
            .humi{
                span{
                    font-size: 16rem;
                }
            }
        }
    }

    .Downmask {
        height: 70rem;
        position: absolute;
        width: 100%;
        bottom: 0;
        z-index: 0;
        // background-image: linear-gradient(rgba(0, 0, 0, 0), rgb(0, 0, 0, 1));
        
        background: linear-gradient(0deg, #F3F9FF 0%, rgba(243, 249, 255, 0.3) 100%);
    }

    .Downmask1 {
        height: 43px;
        position: absolute;
        width: 157px;
        bottom: 100rem;
        left: 24rem;
        z-index: 0;
        background: #ffffff;
        border-radius: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .Downmask1:hover {
        background-color: rgba(102, 160, 207, 0.9);
    }

    .rouling {
        width: 87px;
        height: 13px;
        font-size: 16px;
        font-family: "YouSheBiaoTiHei";
        font-weight: 400;
        color: #333333;
        line-height: 14px;
        white-space: nowrap;
        margin-left: 7rem;
    }

    .clickbtn-rongt {
        width: 3.4vw;
        height: 22.5vh;
        position: absolute;
        top: 0;
        bottom: 0;
        margin: auto;
        z-index: 0;
        background: #ffffff;
        border-radius: 12px;
        cursor: pointer;
        bottom: 80rem;
        left: 24rem;
        display: flex;
        align-items: center;
        padding: 0.5vh 0;
        justify-content: space-evenly;
        flex-direction: column;
        
        .nin_select{
            width: 100%;
            height: 55rem;
            padding-top: 5rem;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            box-sizing: border-box;
            border:2px solid transparent ;
            &>img{
                display: block; 
                width:22px ;
                height: 20px;
            }
            &>span{
                display: block;
                color: #333;
                font-size: 14px;
            }
        }
        
        .selected{
            border-right:2px solid #0d94ff ;
            color: #0d94ff;
            background-color: rgba(13,148,255, 0.1);
        }
        

        .sitePoPup{
            position: absolute;
            right: -6.5vw;
            top: 6.2vh;
            width:5.3vw;
            height: 10vh;
            background-color: #fff;
            display: flex;
            flex-direction: column;
            color: #333;
            justify-content:center;
            align-items: center;
            border-radius: 8px;

            
            .siteCon{
                width:4vw ;
                height: 4vh;
                text-align: center;
                line-height: 36px;
                border-bottom: 1px solid rgba(0, 0, 0, 0.08);
                
                &:hover{
                    color: #0d94ff;
                }
            }
            .se{
                    color: #0d94ff;
                }
            .siteCon:last-child{
                border: none;
            }
        }
        .sitePoPup:before{
            content: '';
            width: 0;
            height: 0;
            border: 1vh solid transparent;
            border-right: 1vh solid #fff;
            position: absolute;
            left: -1vw;
            top: 4vh;
        }
    }

    .clickbtn-rongt1 {
        z-index: 111;
        cursor: pointer;
        position: absolute;
        width: 8.2vw;
        bottom: 155rem;
        left: 24rem;
        z-index: 0;
        background: #ffffff;
        border-radius: 12px;
        padding: 8px 2px 0;
        display: flex;
        align-items: center;
        flex-direction: column;
        .nin_select{
            width: 100%;
            height: 25px;
            line-height: 25px;
            border-radius: 7px;
            display: flex;  
            justify-content: space-between;
            padding: 0 14px;
            background-color: #fff;
            margin-bottom: 6px;
            span{
                img{
                    width: 18rem;
                    height: 18rem;
                    vertical-align: middle;
                    margin-top: -1px;
                    margin-right: 8px;
                }
            }
            &:hover{
                // color:#0d94ff;
                background-color: #e2f2ff;
            }
        }
        .selected{
            color:#0d94ff;
            background-color: #e2f2ff;
        }
    }

    .nin_btn{
        // height: 43px;
        z-index: 111;
        cursor: pointer;
        position: absolute;
        width: 8.2vw;
        bottom: 155rem;
        left: 24rem;
        z-index: 0;
        background: #ffffff;
        border-radius: 12px;
        padding: 8px 2px 0;
        display: flex;
        align-items: center;
        flex-direction: column;
        .nin_select{
            width: 100%;
            height: 25px;
            line-height: 25px;
            border-radius: 7px;
            display: flex;  
            justify-content: space-between;
            padding: 0 14px;
            background-color: #fff;
            margin-bottom: 6px;
            span{
                img{
                    width: 10px;
                    height: 14px;
                    vertical-align: middle;
                    margin-top: -1px;
                    margin-right: 8px;
                }
            }
            &:hover{
                // color:#0d94ff;
                background-color: #e2f2ff;
            }
        }
        .selected{
            color:#0d94ff;
            background-color: #e2f2ff;
        }
        
    }

    .floor{
        width: 3.4vw;
        height: 22.5vh;
        position: absolute;
        top: 0;
        bottom: 0;
        margin: auto;
        z-index: 0;
        background: #fff;
        border: 1px solid #0d94ff;
        border-radius: 12px;
        cursor: pointer;
        bottom: 80rem;
        right: 24rem;
        
        padding: 1.5vh 0;
        .top{
            width: 0;
            height: 0;
            position: absolute;
            top: -4rem;
            left: calc(1.7vw - 8rem);
            border:8rem solid transparent ;
            border-bottom: 8rem solid #000;
        }
        .bottom{
            width: 0;
            height: 0;
            position: absolute;
            bottom:  -4rem;
            left: calc(1.7vw - 8rem);
            border:8rem solid transparent ;
            border-top: 8rem solid #000;
        }
        .top1{
            border-bottom: 8rem solid rgba(0, 0, 0, 0.15);
        }
        .bottom{
            border-top: 8rem solid rgba(0, 0, 0, 0.15);
        }
        .warp{
            width: 100%;
            max-height: 19.5vh;
            overflow:scroll;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            .flooritem{
                height: 3.5vh;
                line-height: 3.5vh;
                width: 100%;
                text-align: center;
                // background: #0d94ff;
                margin-bottom: 0.5vh ;
            }
            .flooritem:last-child{
                margin-bottom: 0 ;
            }
            .se{
                border-right:2px solid #0d94ff ;
                color: #0d94ff;
                background-color: rgba(13,148,255, 0.1);
            }
        }
        .warp::-webkit-scrollbar{
            display: none;
        }
    }
</style>